import { render, staticRenderFns } from "./BattleBracketsFinalSparring.vue?vue&type=template&id=2daed867&scoped=true"
import script from "./BattleBracketsFinalSparring.vue?vue&type=script&lang=js"
export * from "./BattleBracketsFinalSparring.vue?vue&type=script&lang=js"
import style0 from "./BattleBracketsFinalSparring.vue?vue&type=style&index=0&id=2daed867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daed867",
  null
  
)

export default component.exports